import React, {Component, createRef} from "react";
import Select from "react-select";

import {connect} from "react-redux";
import isEqual from "lodash/isEqual";

import {fetchBrands} from "../../../../store/slices/admin/brands";
import {fetchSections} from "../../../../store/slices/admin/sections";
import { DebouncedFunc, debounce } from "lodash";

type Props = {
	isEdit: boolean,
	brands: Array<string>,
	sections: Array<string>,
	cellId: number,
	type: string,
	id: number,
	updateConfig: Function,
	// injected
	dispatch: Function,
	brandsData:	[{value: string, label: string}],
	isLoadingBrands: boolean,
	sectionsData: Array<number>,
	isLoadingBigscreenSettings: boolean,
	isLoadingSections: boolean,
	isSectionsDisabled: boolean,
}

type OptionType = {
	value: string;
	label: string;
};

type State = {
	selectedSections:  OptionType[],
	selectedBrands:  OptionType[],
	sectionSearch: string
}

class Sections extends Component<Props, State> {
	brandsSelectRef: React.RefObject<any>;
	additionalSections: Array<string>;
	getSectionOptions: DebouncedFunc<(inputValue: string) => void>;

	constructor(props: Props) {
		super(props);
		this.state = {
			selectedSections: [],
			selectedBrands: [],
			sectionSearch: ''
		};

		this.getSectionOptions = debounce(this._getSectionOptions, 400);
		this.additionalSections = props.sections;

		this.onSectionChange = this.onSectionChange.bind(this);
		this.onBrandChange = this.onBrandChange.bind(this);
		this.brandsSelectRef = createRef();
	}

    static defaultProps = {
        isSectionsDisabled: false
    }

    componentDidMount() {
        this.props.dispatch(fetchBrands());
		this.setInitBrands();
		this.setInitSections();
    }

    componentDidUpdate(prevProps: Props) {
		if (!isEqual(prevProps.brands, this.props.brands)) {
			const brands = this.props.brands.join(',');
			this.props.dispatch(fetchSections(brands, this.props.type, "", this.additionalSections, this.props.cellId));
        }
		
		if (!isEqual(prevProps.brandsData, this.props.brandsData) || (prevProps.id !== this.props.id || !isEqual(prevProps.sections, this.props.sections))) {
			this.setInitBrands();
		}

		if (!isEqual(prevProps.sectionsData, this.props.sectionsData) || (prevProps.id !== this.props.id || !isEqual(prevProps.sections, this.props.sections))) {
			this.setInitSections();
		}

		if (prevProps.type !== this.props.type) {
			this.additionalSections = [];
			this.setState({ selectedSections: [] }, () => {
				const brands = this.props.brands.join(',');
				this.props.dispatch(fetchSections(brands, this.props.type, "", this.additionalSections, this.props.cellId));
			});
		}
    }

	_getSectionOptions = (inputValue: string) => {
		if (this.props.brands.length > 0 && inputValue !== this.state.sectionSearch) {
			this.setState({ sectionSearch: inputValue });

			const brands = this.props.brands.join(',');
			this.props.dispatch(fetchSections(brands, this.props.type, inputValue, this.additionalSections, this.props.cellId));
		}
	};

    setInitBrands() {
		const brands = this.props.brands;
		const brandsData = this.props.brandsData;
		let selectedBrands: any[] = [];
		if (brandsData.length > 0 && brands.length > 0) {
			selectedBrands = brandsData.filter(item => brands.indexOf(item.value) !== -1);
		}

		if (selectedBrands.length > 0) {
			const brands = this.props.brands.join(',');
			this.props.dispatch(fetchSections(brands, this.props.type, "", this.additionalSections, this.props.cellId));
		}

		this.setState({selectedBrands});
	}

	setInitSections() {
		const sections = this.props.sections;
		const sectionsData = this.props.sectionsData[this.props.cellId];
		let selectedSections: any[] = [];
		let filteredSections: any[] = [];
		if (sectionsData && sections.length > 0) {
			this.props.brands.forEach((brand: string) => {
				// @ts-ignore
				if (sectionsData && sectionsData[brand] ) {
					// @ts-ignore
					selectedSections = [...this.state.selectedSections, ...sectionsData[brand]];
					selectedSections = selectedSections.filter(item => sections.indexOf(item.value) !== -1);
					// @ts-ignore
					filteredSections =  selectedSections.filter((item, index, self) => 
						index === self.findIndex(obj => obj.value === item.value && obj.label === item.label)
				  	);
				}
			});
		}
		this.setState({selectedSections : filteredSections});
	}

    getOptions() {
        let selectSections: any[] = [];
		const sectionsData = this.props.sectionsData ? this.props.sectionsData[this.props.cellId] : undefined;
        if (this.props.brands.length > 0) {
            this.props.brands.forEach(brand => {
				// @ts-ignore
                if (sectionsData && sectionsData[brand]) {
					// @ts-ignore
                    selectSections = [...selectSections, ...sectionsData[brand]];
                }
            });
        } else {
			// @ts-ignore
            if (sectionsData && sectionsData.length > 0) {
                Object.getOwnPropertyNames(sectionsData).forEach(brand => {
					// @ts-ignore
                    selectSections = [...selectSections, ...sectionsData[brand]];
                });
            }
        }

        return selectSections;
    }

    onBrandChange(value: OptionType[]) {
        let brands = [...this.props.brands];
        let sections = [...this.props.sections];
        if (!value || value.length < 1) {
            brands = [];
            sections = [];
        } else {
            const oldBrands = brands;
            brands = value.map((item: OptionType) => item.value);

            if (oldBrands.length > brands.length) {
                const removedBrand = oldBrands.find(brand => !brands.includes(brand));
                sections = sections.filter(section => !section.startsWith(removedBrand + "_"));
            } else if (oldBrands.length === 0 && brands.length && sections.length) {
                sections = sections.filter(section => section.startsWith(brands[0] + "_"));
            }
        }

		const selectedSections = this.filterSections(brands, sections);
		const selectedBrands = value;
		this.setState({selectedBrands, selectedSections}, () => {
			this.props.updateConfig(["brands", "sections"], [brands, sections]);
		});

		this.brandsSelectRef.current?.blur();
    }

    onSectionChange(value: OptionType[]) {
		this.setState({selectedSections: value}, () => {
			this.props.updateConfig(["sections"], [(!value || value.length < 1) ? [] : value.map(item => item.value)]);
		});
    }

    filterSections(brands: Array<string>, sections: Array<string>,) {
		const sectionsData = this.props.sectionsData[this.props.cellId];
		let data: any[] = [];
		if (sectionsData) {
			/* eslint-disable */
			Object.keys(sectionsData).map(item => {
				if (brands.indexOf(item) !== -1) {
					// @ts-ignore
					if (sectionsData[item].length > 0) {
						// @ts-ignore
						data.push(sectionsData[item]);
					}
				}
			});
			/* eslint-disable */
			data = data.flat();

			return data.filter(item => sections.indexOf(item.value) !== -1);
		}

		return [];
	}

    render() {
        return (
			<div>
				<div className="config-item__selects">
					<div className="form-group">
						<label htmlFor="sortBy1">Brand/Multibrand</label>
						<Select
							id="sortBy1"
							className="basic-single"
							classNamePrefix="so-select-sort"
							isSearchable={true}
							isMulti
							ref={this.brandsSelectRef}
							value={this.state.selectedBrands}
							options={this.props.brandsData}
							onChange={(option) => this.onBrandChange((option as OptionType[]))}
							isLoading={this.props.isLoadingBrands}
							isDisabled={this.props.isLoadingBigscreenSettings}
							isOptionDisabled={() => this.state.selectedBrands && this.state.selectedBrands.length > 50}
							menuPortalTarget={document.body}
							styles={{menuPortal: base => ({...base, zIndex: 9999})}}
						/>
					</div>
					
					<div className="form-group">
						<label htmlFor="sortBy2">Full site/Sections</label>
						<Select
							id="sortBy2"
							className="basic-single"
							classNamePrefix="so-select-sort"
							isSearchable={true}
							isMulti
							value={this.state.selectedSections}
							options={this.getOptions()}
							onChange={(option) => this.onSectionChange((option as OptionType[]))}
							onInputChange={this.getSectionOptions}
							closeMenuOnSelect={false}
							isLoading={this.props.isLoadingSections}
							menuPortalTarget={document.body}
							styles={{menuPortal: base => ({...base, zIndex: 9999})}}
							isDisabled={this.props.isSectionsDisabled}
						/>
					</div>
				</div>
			</div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        brandsData: state.brands.data,
        isLoadingBrands: state.brands.isLoading,
        sectionsData: state.sections.cellId ? state.sections.data : [],
        isLoadingSections: state.sections ? state.sections.isLoading : false,
		isLoadingBigscreenSettings: state.bigscreenSettings ? state.bigscreenSettings.isLoading : {}
    }
};

export default connect(mapStateToProps)(Sections);
